'use strict'

const bs = [...document.querySelector('.switch-category-inner').children];
const cs = [...document.querySelector('.categorys').children];
const bcur = 'switch-category-button-current';
const switchCategory = idx => {
  for (let i=0; i<bs.length; ++i) {
    if (i === idx) {
      bs[i].classList.add(bcur);
      cs[i].hidden = false;
      continue;
    }
    bs[i].classList.remove(bcur);
    cs[i].hidden = true;
  }
};
bs.forEach((b, idx) => {
  b.onclick = () => {
    switchCategory(idx);
  };
});
bs[0].classList.add(bcur);
cs.slice(1).forEach(c => {
  c.hidden = true;
});
